import { supabase } from '../supabase';

export const fetchOneAssignedTaskers = (taskId: number) => {
  return supabase
    .from('assigned_taskers')
    .select(
      `
        *,
        tasker:tasker_id (
          id,
          name,
          last_name,
          email,
          phone_number,
          university,
          career,
          carreer,
          university_year,
          auth_id
        )
      `
    )
    .eq('task_id', taskId);
};

export const createAssignedTasker = (taskId: number, taskerId: number) => {
  return supabase.from('assigned_taskers').insert([{ task_id: taskId, tasker_id: taskerId }]);
};

export const deleteAssignedTasker = (taskId: number, taskerId: number) => {
  return supabase.from('assigned_taskers').delete().eq('task_id', taskId).eq('tasker_id', taskerId);
};
